import cliente from './cliente';
import articulo from './articulo';
import usuario from './usuario';
import categoria from './categoria';
import tipoProducto from './tipoProducto';
import departamento from './departamento';
import pedido from './pedido';
import openpay from './openpay';
import mp from './mp';

function plugin(Vue) {
    Vue.prototype.$api = {
        cliente,
        articulo,
        usuario,
        categoria,
        departamento,
        tipoProducto,
        pedido,
        openpay,
        mp
    };
}

if (typeof window !== 'undefined' && window.Vue) { // eslint-disable-line no-undef
    window.Vue.use(plugin); // eslint-disable-line no-undef
}

// module.exports = plugin;
export default plugin;


// WEBPACK FOOTER //
// ./src/common/resources/index.js